/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
    MediaRootMiniReference,
    MediaRootMiniReferenceFromJSON,
    MediaRootMiniReferenceFromJSONTyped,
    MediaRootMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubclipReference
 */
export interface SubclipReference {
    /**
     * 
     * @type {number}
     * @memberof SubclipReference
     */
    id: number;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubclipReference
     */
    asset: AssetMiniReference;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubclipReference
     */
    rendered?: AssetMiniReference;
    /**
     * 
     * @type {boolean}
     * @memberof SubclipReference
     */
    readonly shared?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SubclipReference
     */
    readonly date?: Date;
    /**
     * 
     * @type {string}
     * @memberof SubclipReference
     */
    readonly name?: string;
    /**
     * 
     * @type {number}
     * @memberof SubclipReference
     */
    readonly tIn?: number;
    /**
     * 
     * @type {number}
     * @memberof SubclipReference
     */
    readonly tOut?: number;
    /**
     * 
     * @type {number}
     * @memberof SubclipReference
     */
    readonly user?: number;
    /**
     * 
     * @type {MediaRootMiniReference}
     * @memberof SubclipReference
     */
    root: MediaRootMiniReference;
}

export function SubclipReferenceFromJSON(json: any): SubclipReference {
    return SubclipReferenceFromJSONTyped(json, false);
}

export function SubclipReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubclipReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': AssetMiniReferenceFromJSON(json['asset']),
        'rendered': !exists(json, 'rendered') ? undefined : AssetMiniReferenceFromJSON(json['rendered']),
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'tIn': !exists(json, 't_in') ? undefined : json['t_in'],
        'tOut': !exists(json, 't_out') ? undefined : json['t_out'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'root': MediaRootMiniReferenceFromJSON(json['root']),
    };
}

export function SubclipReferenceToJSON(value?: SubclipReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'asset': AssetMiniReferenceToJSON(value.asset),
        'rendered': AssetMiniReferenceToJSON(value.rendered),
        'root': MediaRootMiniReferenceToJSON(value.root),
    };
}


